import { Box, Typography, Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PetsIcon from '@mui/icons-material/Pets';

interface PageHeaderProps {
  onBack: () => void;
}

export function PageHeader({ onBack }: PageHeaderProps) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
      <Button
        variant="outlined"
        startIcon={<ArrowBackIcon />}
        onClick={onBack}
        sx={{ 
          borderRadius: 2, 
          px: 2, 
          py: 1, 
          textTransform: 'none',
          borderColor: '#E0E7EF',
          color: '#6B7280',
          '&:hover': {
            borderColor: '#D1D5DB',
            bgcolor: '#F9FAFB'
          }
        }}
      >
        Voltar
      </Button>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <PetsIcon sx={{ color: '#3B82F6', fontSize: 28 }} />
        <Typography variant="h4" fontWeight={700} color="#111827">
          Detalhes do Pet
        </Typography>
      </Box>
    </Box>
  );
} 